import React, { useEffect } from "react";
import "./Features.css";
import AOS from "aos";
import "aos/dist/aos.css";
import spt3DLogo from "../../assets/images/spt 3d logo.png";
import spt3DMobile from "../../assets/images/spt 3d logo-mobile.png";
import safeIcon from "../../assets/images/safeIcon.png";
import firstFeatureIcon from "../../assets/images/first-icon-features.png";
import secondFeatureIcon from "../../assets/images/second-icon-features.png";
import thirdFeatureIcon from "../../assets/images/third-icon-features.png";
import featureIllustration from "../../assets/gif/SPT-features.GIF";
import { useTranslation } from "react-i18next";
const Features = () => {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="features-container">
      <div className="features-details">
        <div className="features-text">
          <h4 data-aos="fade-right" data-aos-duration="1000">
            {t("Smartest")} Gamers Wallet: {t("Safe")} , {t("Secure")}{" "}
            {t("And")} {t("Rewarding")}{" "}
            <img
              src={safeIcon}
              alt="Gamers Wallet Icon"
              className="feature-text-icon"
            />
          </h4>
          <p data-aos="fade-right" data-aos-duration="1500">
            Sportrex Gamers Wallet {t("is")} {t("a")} {t("decentralized")}{" "}
            {t("gamers")} {t("wallet")} {t("that")} {t("gives")} {t("you")}{" "}
            {t("complete")} {t("control")} {t("over")} {t("your")} {t("funds")}{" "}
            {t("while")} {t("prioritizing")} {t("security")}. {t("You")}{" "}
            {t("can")} {t("earn")} {t("exclusive")} {t("gaming")} {t("rewards")}{" "}
            {t("and")} {t("crypto")} {t("cash")}-{t("back")} {t("with")}{" "}
            {t("every")} {t("use")} {t("of")} {t("our")} {t("card")}. <br />
            <br />
            <strong>
              {t("Download")} Sportrex Gamers Wallet {t("today")} {t("and")}{" "}
              {t("level")} {t("up")}.
            </strong>
          </p>
          <div className="features-more-details">
            <div className="features-more-details-text-icon">
              <div
                className="features-text-icon"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <img src={firstFeatureIcon} alt="First Features" />
                <div className="line"></div>
              </div>
              <h5 data-aos="fade-left" data-aos-duration="1000">
                {t("Your")} crypto, {t("your")} {t("rules")}. {t("Youre")}{" "}
                {t("the")} {t("only")} {t("one")} {t("with")} {t("the")}{" "}
                {t("keys")} {t("to")} {t("your")} {t("crypto")}, {t("so")}{" "}
                {t("youre")} {t("in")} {t("charge")}.
              </h5>
            </div>

            <div className="features-more-details-text-icon">
              <div
                className="features-text-icon"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <img src={secondFeatureIcon} alt="Second Features" />
                <div className="line"></div>
              </div>
              <h5 data-aos="fade-left" data-aos-duration="2000">
                {t("Our")} smart contract {t("is")} {t("audited")} {t("by")}{" "}
                {t("by")} {t("top")} {t("audit")} {t("firms")} {t("and")}{" "}
                {t("constantly")} {t("reviewed")} {t("to")} {t("ensure")}{" "}
                {t("maximum")} {t("security")} {t("for")} {t("your")}{" "}
                {t("funds")}.
              </h5>
            </div>
            <div className="features-more-details-text-icon">
              <div
                className="features-text-icon"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <img src={thirdFeatureIcon} alt="Third Features" />
              </div>
              <h5 data-aos="fade-left" data-aos-duration="3000">
                {t("Convenience")} - {t("Trade")} {t("anywhere")},{" "}
                {t("anytime")}, {t("with")}
                {t("ease")}.
              </h5>
            </div>
          </div>
        </div>
        <div className="features-illustration">
          <img src={featureIllustration} alt="Gamers Wallet Illustration" />
        </div>
      </div>
      <div className="spt-features-logo">
        <img
          src={spt3DLogo}
          alt="spt features logo"
          className="spt-logo-desktop"
        />
        <img
          src={spt3DMobile}
          alt="spt features mobile"
          className="spt-logo-mobile"
        />
      </div>
    </div>
  );
};

export default Features;
